import { ShellProps } from '../../typings';
import isFunction from '../../helpers/is-function';
import loadScript from '../load-script/load-script';

const loadGlobals = async ({ config }: ShellProps, cb?: any) => {
  const { globals } = config;
  // loop through all objects
  // check if function or string
  //* if function, await, and resolve it
  // ?if string, download file, and eval it??
  //* do we need to check if we are in ssr? we will need to...

  // ?How does adding it to global work in ssr??

  if (!globals || Object.keys(globals).length === 0) return Promise.resolve();

  // this will await till all files have been loaded.
  return Promise.all(
    Object.entries(globals).map(
      async ([key, value]) =>
        new Promise(async resolve => {
          try {
            const isLocalImport = isFunction(value);
            if (key && value) {
              if (cb) cb(`adding ${key} to globals`);

              // TODO: should we allow globals to load with manifest.json??
              global[key] = isLocalImport
                ? await value()
                : await loadScript({ url: value as any, name: key });
            }

            return resolve();
          } catch (error) {
            throw new Error(`could not globally load ${key} library`);
          }
        })
    )
  );
};

export default loadGlobals;
